'use client';

import { forwardRef, type HTMLAttributes } from 'react';
import { P } from '@paypoteam/ui-components/P';
import parse from 'html-react-parser';

import { cn } from '@/lib/utils';

import {
    LocalImage,
    type LocalImageProps,
} from '@/components/atoms/LocalImage';
import H2 from '@/components/atoms/Typography/H2';
import Section from '@/components/layout/Section';

export interface ColorSideSectionProps extends HTMLAttributes<HTMLDivElement> {
    title: string;
    description: string;
    isReverse?: boolean | null | undefined;
    image: LocalImageProps;
    'data-test-id'?: string;
}

const ColorSideSection = forwardRef<HTMLDivElement, ColorSideSectionProps>(
    ({ title, description, image, isReverse, ...props }, ref) => (
        <Section
            ref={ref}
            {...props}
        >
            <div
                className={cn(
                    'flex w-full flex-col items-center justify-between md:flex-row',
                    isReverse ? 'md:flex-row' : 'md:flex-row-reverse',
                )}
            >
                <aside
                    className={cn(
                        'relative m-14 h-[325px] w-[310px] md:m-0 md:h-[380px] md:w-[360px] xl:h-[556px] xl:w-[556px]',
                    )}
                >
                    <LocalImage
                        fill
                        {...image}
                    />
                </aside>

                <article className="flex w-full max-w-[520px] flex-col justify-center space-y-5 md:w-1/2">
                    <H2 className="text-left">{title}</H2>

                    <P>{parse(description)}</P>
                </article>
            </div>
        </Section>
    ),
);

export default ColorSideSection;
